export const WarningIconBig = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.8882 12.4405L9.42164 42.6912C9.10613 43.2375 8.94 43.8572 8.93994 44.4881C8.93988 45.1189 9.1059 45.7387 9.42131 46.285C9.73672 46.8314 10.1904 47.2851 10.7367 47.6005C11.2831 47.9159 11.9028 48.0819 12.5337 48.0819H47.464C48.0948 48.0819 48.7146 47.9159 49.2609 47.6005C49.8073 47.2851 50.2609 46.8314 50.5764 46.285C50.8918 45.7387 51.0578 45.1189 51.0577 44.4881C51.0577 43.8572 50.8915 43.2375 50.576 42.6912L33.1113 12.4405C32.796 11.8943 32.3424 11.4407 31.7962 11.1254C31.25 10.8101 30.6305 10.644 29.9998 10.644C29.3691 10.644 28.7495 10.8101 28.2033 11.1254C27.6571 11.4407 27.2036 11.8943 26.8882 12.4405Z"
        fill="#FB3748"
      />
      <path
        d="M30.2274 21.7705H29.7718C28.6501 21.7705 27.7407 22.6799 27.7407 23.8016V33.5099C27.7407 34.6316 28.6501 35.541 29.7718 35.541H30.2274C31.3492 35.541 32.2585 34.6316 32.2585 33.5099V23.8016C32.2585 22.6799 31.3492 21.7705 30.2274 21.7705Z"
        fill="#FFF7ED"
      />
      <path
        d="M29.9996 43.2405C31.2472 43.2405 32.2585 42.2291 32.2585 40.9816C32.2585 39.734 31.2472 38.7227 29.9996 38.7227C28.7521 38.7227 27.7407 39.734 27.7407 40.9816C27.7407 42.2291 28.7521 43.2405 29.9996 43.2405Z"
        fill="#FFF7ED"
      />
    </svg>
  );
};
